import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button/Button';

import withIdContext from '../../decorators/withIdContext';
import StandardActionWithMenu from './StandardActionWithMenu/StandardActionWithMenu';

const StandardAction = ({
  disabled,
  label,
  onClick,
  type,
  isLoading,
}) => (
  <Button
    type={type}
    disabled={disabled}
    onClick={onClick}
    isLoading={isLoading}
  >
    {label}
  </Button>
);

StandardAction.WithMenu = StandardActionWithMenu;

StandardAction.propTypes = {
  /** Button label */
  label: PropTypes.string,
  /** Button type */
  type: PropTypes.oneOf(['button', 'reset', 'submit']),
  /** Disable button */
  disabled: PropTypes.bool,
  /** Loading spinner and disabling button */
  isLoading: PropTypes.bool,
  /** Gets called when the user clicks on the button */
  onClick: PropTypes.func.isRequired,
};

StandardAction.defaultProps = {
  label: '',
  type: 'button',
  disabled: false,
  isLoading: false,
};

export default withIdContext()(StandardAction);
